module.exports = __webpack_public_path__ + "static/media/charter-flights-icon.775e7e1b.PNG";